/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BanUserFromCommunityBody
 */
export interface BanUserFromCommunityBody {
    /**
     * 
     * @type {string}
     * @memberof BanUserFromCommunityBody
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof BanUserFromCommunityBody
     */
    groupingId: string;
}

export function BanUserFromCommunityBodyFromJSON(json: any): BanUserFromCommunityBody {
    return BanUserFromCommunityBodyFromJSONTyped(json, false);
}

export function BanUserFromCommunityBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BanUserFromCommunityBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'groupingId': json['groupingId'],
    };
}

export function BanUserFromCommunityBodyToJSON(value?: BanUserFromCommunityBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'groupingId': value.groupingId,
    };
}


